import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { scopeNotFoundText } from './scopeNotFound.ts'

/** Stands in for a project's or order's data when fetching the project or order itself answered 404. */
export function ScopeNotFoundNotice({ scopeKind }: { scopeKind?: 'project' | 'order' }) {
  return (
    <div role="alert" data-testid="scope-not-found" className="alert alert-warning">
      <ExclamationTriangleIcon className="w-5 h-5" />
      <span>{scopeNotFoundText(scopeKind)}</span>
    </div>
  )
}
